/** Customer batch REST paths (relative; `mapCustomerPath` adds `/v1/customer` when needed). */
export const CUSTOMER_BATCH = "/batch";

/** Legacy create / generate-download-link (zoop-dashboard parity; no `/batch` prefix on SDS). */
export const CUSTOMER_BATCH_LEGACY = "/productBatchService";

export const batchPaths = {
  types: `${CUSTOMER_BATCH}/types`,
  tasks: `${CUSTOMER_BATCH}/tasks`,
  createTask: `${CUSTOMER_BATCH_LEGACY}/createTask`,
  generateDownloadLink: (batchId: string) =>
    `${CUSTOMER_BATCH_LEGACY}/generateDownloadLink/${encodeURIComponent(batchId)}`,
  taskActions: `${CUSTOMER_BATCH}/tasks/actions`,
} as const;
